import { Audit } from 'entities/entity';
import { Rule } from '../rules';
import { Channel } from './channels';
import { SubFeature } from './subfeatures';

export enum EventTriggers {
  EMAIL_CHANGED = 'EMAIL_CHANGED',
  PHONE_CHANGED = 'PHONE_CHANGED',
  INACTIVITY = 'SalecycleEvent:Inactivity',
}

export interface Ruleset {
  audit?: Audit;
  campaignId?: string;
  channels?: Channel[];
  compositeKey?: string;
  eventTriggers?: EventTriggers[];
  name?: string;
  rules?: Rule[];
  subFeature?: SubFeature;
}
